const jaMessages = {
  /* 01.General */
    "main.name": "名前",
  "main.sentiment": "感情",
  "main.urgency": "緊急度",
  "main.language": "言語",
  "main.agent": "エージェント",
  "main.property_name": "施設名",
  "main.booking_number": "予約番号",
  "main.check_out": "チェックアウト",
  "main.check_in": "チェックイン",
  "main.adults": "大人",
  "main.corporate_code": "法人コード",
  "main.group_code": "グループコード",
  "main.promo_code": "プロモーションコード",
  "main.ai_response": "AI応答",
  "main.template_response": "テンプレート応答",
  "main.converttoticket": "チケットに変換",
  "main.switch_property": "施設を切り替える",
  "main.Group_id": "グループID",
  "main.integration_id": "統合ID",
  "main.submit": "送信",
  "main.cancel": "キャンセル",
    "main.select_template": "テンプレートを選択",
  "main.rooms": "客室",
  "main.rates": "料金",

  //footer
  "footer.knowledge": "ナレッジ",
  "footer.home": "ホーム",
  "footer.help": "ヘルプ",

  //ticket
  "ticket.thank_you": "フォームを送信いただきありがとうございます",
  "ticket.ticket": "チケット",
  "ticket.details": "チケットの詳細を説明するフォームに入力してください。",
  "ticket.select_category": "カテゴリーを選択",
  "ticket.category": "カテゴリー",
  "ticket.title": "タイトル",
  "ticket.notes": "メモ",
  "ticket.status": "ステータス",
  "ticket.assigned_to": "割り当て先",
  "ticket.submit_form": "フォームを送信",

  
  "main.total": "合計",
  "main.pastetooutlook": "Outlookに貼り付け",
  "main.children": "子供",
  "main.promocode": "プロモーション/法人/グループコード",
  "main.exact_match_only": "完全一致のみ",
  "main.search": "検索",
  "main.no_rate_match": "選択した条件に一致する料金がありません。検索条件を変更して再度お試しください。",
  "main.translate_to": "翻訳先",
  "main.regenerate": "再生成",
  "main.copy_text": "テキストをコピー",
  "main.additional_instructions": "追加指示",

  "faq.helpcenter": "ヘルプセンター",
  "faq.reply.email.sabre.question": "Aven Hospitality Concierge Email Automationを使用してメールに返信するにはどうすればよいですか？",
  "faq.reply.email.sabre.answer": "メールを開き、Aven Hospitalityアドインを起動します。事前定義されたテンプレートの使用、AI応答の生成、またはメールをチケットへ変換する3つのオプションから選択できます。問い合わせに最適なオプションを選択し、応答を確認・編集した後、Outlookから直接送信できます。",

  "faq.rates.availability.question": "返信に料金、空室状況、客室情報を追加するにはどうすればよいですか？",
  "faq.rates.availability.answer": "+ Rates機能を使用して、日付や宿泊人数などのゲスト情報を入力すると、Conciergeが正確な空室状況と料金を返信に追加します。また、+ Roomsを使用して客室説明や画像を追加できます。",

  "faq.different.language.question": "メールが別の言語の場合はどうすればよいですか？",
  "faq.different.language.answer": "Aven Hospitality Conciergeでは受信メールを希望する言語に翻訳できます。その後、返信を作成・編集し、送信前にゲストの言語へ戻すことができます。",

  "faq.pin.addin.question": "Outlookでアドインを常に利用できるようにするにはどうすればよいですか？",
  "faq.pin.addin.answer": "Aven Hospitality Conciergeを常に表示するには、Outlookでアドインをピン留めしてください。",

  "faq.knowledge.hub.question": "Knowledge Hub検索オプションとは何ですか？",
  "faq.knowledge.hub.answer": "Knowledge Hub検索では、Outlook内で施設固有の情報をすばやく検索できます。",

  "faq.reply.email.myma.question": "Mymaを使用してメールに返信するにはどうすればよいですか？",
  "faq.reply.email.myma.answer": "メールを開き、Mymaアドインを起動します。テンプレート使用、AI応答生成、またはチケット変換を選択できます。",

  "faq.room.details.question": "返信に客室情報を追加するにはどうすればよいですか？",
  "faq.room.details.answer": "+ Roomsを使用して客室説明や画像を追加できます。",

  "faq.myma.different.language.question": "メールが別の言語の場合はどうすればよいですか？",
  "faq.myma.different.language.answer": "Mymaでは受信メールを希望する言語に翻訳できます。",

  "faq.myma.pin.addin.question": "Outlookでアドインを常に利用できるようにするにはどうすればよいですか？",
  "faq.myma.pin.addin.answer": "MymaアドインをOutlookでピン留めすると、メールごとに自動的に開きます。",


};
export default jaMessages;